/*
 * Copyright (c) 2021 Mike Vo (info@miketvo.com) - All Rights Reserved.
 *
 * This file is part of the project "miketvo-website".
 *
 * This project is an online personal website by Mike Vo.
 *
 * COPYING AND/OR DISTRIBUTING OF ANY CONTENT WITHIN THIS PROJECT WITHOUT EX-
 * PRESS PERMISSION FROM THE CLIENT AND/OR THE AUTHOR, VIA ANY MEDIUM IS
 * STRICTLY PROHIBITED.
 *
 * Written by Mike Vo on June 27th 2021.
 *
 */

import * as React from "react";

import Layout from "../../components/layout";
import Seo from "../../components/seo";
import SetLang from "../../components/setLang";
import * as headingStyle from "../../styles/heading.module.css";
import * as style from "../styles/contact.module.css";

function validate(ev) {
  if (document.getElementById("reason").value === "0") {
    ev.preventDefault();
    alert("ご連絡いただいた理由をお選びください");
  }
}

const ContactPageJA = () => (
  <Layout lang="ja">
    <Seo title="連絡先" lang="ja" />
    <SetLang lang="ja" />
    <div className={style.wrapper}>
      <section className={style.inquiry}>
        <div
          data-sal="slide-right"
          data-sal-duration="1000"
          className={[headingStyle.dash, headingStyle.solidWhite].join(" ")}
        />
        <h1 data-sal="slide-right" data-sal-duration="1000" data-sal-delay="200" className={headingStyle.heading}>
          ビジネス問い合わせ
        </h1>
        <p data-sal="slide-right" data-sal-duration="1000" data-sal-delay="400">
          私は通常、月曜日から金曜日の営業時間9AMから5PM〜GMT+7〜に返信します。ベトナムと海外の休日が適用される場合があります。
        </p>
        <form
          onSubmit={validate}
          data-sal="slide-right"
          data-sal-duration="1000"
          data-sal-delay="600"
          name="contact-ja"
          action={"/ja/submitted/"}
          method="post"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          className={style.form}
        >
          <input type="hidden" name="bot-field" />
          <input type="hidden" name="form-name" value="contact-ja" />
          <p className={style.notice}>*必須</p>
          <div className={style.field}>
            <input type="text" name="name" id="name" required />
            <label htmlFor="name">お名前</label>
          </div>
          <div className={style.field}>
            <input type="email" name="email" id="email" required />
            <label htmlFor="email">Eメール</label>
          </div>
          <div className={style.field}>
            <input type="text" name="tel" id="tel" />
            <label htmlFor="tel">電話番号</label>
          </div>
          <div className={[style.field, style.fieldRos].join(" ")}>
            <select name="reason" id="reason" required>
              <option value="0" selected>
                1つ選択
              </option>
              <option value="1">サービスパッケージのコンサルティング</option>
              <option value="2">個人用ウェブサイトの見積り</option>
              <option value="3">ビジネスウェブサイトの見積もり</option>
              <option value="4">Eコマースプラットフォームの見積り</option>
              <option value="5">テクニカルサポート</option>
              <option value="6">フィードバック</option>
              <option value="7">その他（下記にご記入ください）</option>
            </select>
            <label htmlFor="reason">ご連絡の理由</label>
          </div>
          <div className={style.message}>
            <div className={style.field}>
              <textarea name="message" id="message" rows={5} required />
              <label htmlFor="message">内容</label>
            </div>
          </div>
          <div className={style.buttonBox}>
            <div className={style.field}>
              <button type="reset">
                <div className={style.before} />
                <div className={style.after} />
                <div className={style.content}>
                  <span>リセット</span>
                </div>
              </button>
              <button type="submit">
                <div className={style.before} />
                <div className={style.after} />
                <div className={style.content}>
                  <span>送信</span>
                </div>
              </button>
            </div>
          </div>
        </form>
      </section>
      <section className={style.contact}>
        <div
          data-sal="slide-left"
          data-sal-duration="1000"
          data-sal-delay="400"
          className={[headingStyle.dash, headingStyle.solidBlack].join(" ")}
        />
        <h1 data-sal="slide-left" data-sal-duration="1000" data-sal-delay="600" className={headingStyle.heading}>
          コンタクトチャンネル
        </h1>
        <ul data-sal="slide-left" data-sal-duration="1000" data-sal-delay="800">
          <li className="animated-anchor-black">
            <a href="tel:0385892705">(+84) 385 892 705</a>
          </li>
          <li className="animated-anchor-black">
            <a href="mailto:info@miketvo.com">info@miketvo.com</a>
          </li>
        </ul>
        <ul data-sal="slide-left" data-sal-duration="1000" data-sal-delay="1000" className={style.social}>
          <li>
            <a href={"https://github.com/miketvo"}>
              <span>GitHub</span>
              <img src={"/media/contact_GitHub.svg"} alt="" />
            </a>
          </li>
          <li>
            <a href={"https://twitter.com/ikxplicitie"}>
              <span>Twitter</span>
              <img src={"/media/contact_Twitter.svg"} alt="" />
            </a>
          </li>
          <li>
            <a href={"https://www.instagram.com/ikxplicitie/"}>
              <span>Instagram</span>
              <img src={"/media/contact_Instagram.svg"} alt="" />
            </a>
          </li>
          <li>
            <a href={"https://www.facebook.com/miketvo/"}>
              <span>Facebook</span>
              <img src={"/media/contact_Facebook.svg"} alt="" />
            </a>
          </li>
        </ul>
      </section>
    </div>
  </Layout>
);

export default ContactPageJA;
